export default function compose(...classLists) {
  return Array.from(new Set(classLists.flat(Infinity)))
}
